import instance from "@/utils/require.js"

// 组装工单--分页查询
export function apiProductionOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/search",
		method: "post",
		data
	})
}

// 组装工单--开始生产
export function apiProductionOrderStart(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/start",
		method: "post",
		data
	})
}

// 组装工单--结单生产
export function apiProductionOrderClose(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/close",
		method: "post",
		data
	})
}

// 组装工单--工单状态统计
export function apiProductionOrderCountByStatus(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/count_by_status",
		method: "post",
		data
	})
}

// 组装工单--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 组装工单--产品类别列表
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 组装工单--产品型号列表
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 组装工单--工单状态列表
export function apiOrderStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/order_status",
		method: "post",
		data
	})
}

// 工单详情--工单详情
export function apiProductionOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/detail",
		method: "post",
		data
	})
}
// 工单详情--修改组装单号
export function apiUpdateOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_order_number",
		method: "post",
		data
	})
}

// 工单详情--修改SAP单号
export function apiUpdateSapOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_sap_order_number",
		method: "post",
		data
	})
}

// 工单详情--修改送检批次数量
export function apiUpdateBatchQuantity(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_batch_quantity",
		method: "post",
		data
	})
}
// 工单详情--修改批次抽检率
export function apiUpdatCheckRate(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_check_rate",
		method: "post",
		data
	})
}
// 工单详情--修改批次合格率
export function apiUpdateQualifiedRate(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_qualified_rate",
		method: "post",
		data
	})
}
// 工单详情--Flash烧录
export function apiOutwardFw(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/outward/fw",
		method: "post",
		data
	})
}
// 工单详情--修改裸机编码
export function apiUpdateItemCode(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_item_code",
		method: "post",
		data
	})
}
// 工单详情--修改计划交货时间
export function apiUpdatePlanFinishDateTime(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_plan_finish_date",
		method: "post",
		data
	})
}

// 工单详情--修改开始生产时间
export function apiUpdateStartDateTime(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_start_date_time",
		method: "post",
		data
	})
}

// PE工程师列表
export function apiUserPEList(data = {}) {
	return instance({
		url: "/aim/api/v3/user/pe_list",
		method: "post",
		data
	})
}

// 工单详情--修改PE工程师
export function apiUpdateMembers(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_members",
		method: "post",
		data
	})
}

// 工单详情--修改客户定制信息
export function apiUpdateCustomization(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_customization",
		method: "post",
		data
	})
}

// 工单详情--修改版本
export function apiUpdateVersion(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_version",
		method: "post",
		data
	})
}

// 工单详情--修改生产信息
export function apiUpdateSNprefix(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_sn_prefix",
		method: "post",
		data
	})
}

export function apiDeviceUpsert(data = {}) {
	return instance({
		url: "/aim/api/v3/amap/upsert",
		method: "post",
		data
	})
}

// 工单详情--修改校验信息
export function apiUpdateCheckInfo(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_check_info",
		method: "post",
		data
	})
}
// 工单详情--修改首件信息
export function apiUpdateFai(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_fai",
		method: "post",
		data
	})
}

// 工单详情--修改校验信息
export function apiUpdateQcBandwidth(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_qc_bandwidth",
		method: "post",
		data
	})
}

// 工单详情--修改扩展信息
export function apiUpdateExtendInfo(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_extend_info",
		method: "post",
		data
	})
}

export function apiExportMacs(data={}) {
	return instance({
		url: "/aim/api/v3/production_order/macs",
		method: "post",
		data
	})
}

// 产品列表--表格查询
export function apiProductionOrderDevices(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/devices",
		method: "post",
		data
	})
}
export function apiExportShipmentOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/export_shipmentOrder",
		method: "post",
		data
	})
}

// 产品列表--当前工序列表
export function apiProductionOrderStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/status_list",
		method: "post",
		data
	})
}

// 产品列表--当前工序列表
export function apiProductionOrderStatusList2(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/status_list2",
		method: "post",
		data
	})
}

// 绑定上传信息
export function apiProductionOrderBindFid(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/bind_fid",
		method: "post",
		data
	})
}

// 配件列表--表格查询
export function apiProOrderPartList(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/device_parts",
		method: "post",
		data
	})
}

// 配件列表--解绑配件
export function apiPartUnbindDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/device",
		method: "post",
		data
	})
}

// 配件列表--解绑零件
export function apiPartUnbind(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/part",
		method: "post",
		data
	})
}

// 生产状态--产品状态
export function apiProductionOrderDeviceStatus(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/devices_status",
		method: "post",
		data
	})
}
export function apiProductionOrderDeviceStatus2(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/devices_status2",
		method: "post",
		data
	})
}

// 生产状态--配件状态
export function apiProOrderDevicePart(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/devices_part_status",
		method: "post",
		data
	})
}

// 生产工序--生产线
export function apiProductionLine(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/production_line",
		method: "post",
		data
	})
}

// 生产工序--表格Sop
export function apiProductSopSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/search",
		method: "post",
		data
	})
}

// 生产工序--新增sop
export function apiProductSopAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/add",
		method: "post",
		data
	})
}

// 生产工序--修改sop
export function apiProductSopUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/update",
		method: "post",
		data
	})
}

// 生产工序--禁用sop
export function apiProductSopDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/disable",
		method: "post",
		data
	})
}

// 生产工序--启用sop
export function apiProductSopEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/enable",
		method: "post",
		data
	})
}

// 生产工序--删除sop
export function apiProductSopDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/delete",
		method: "post",
		data
	})
}
// 生产工序--回退到上一工序
export function apiProductionOrderSopRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/rollback",
		method: "post",
		data
	})
}

// 生产工序--下移sop
export function apiProductSopMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/move_down",
		method: "post",
		data
	})
}

// 生产工序--上移sop
export function apiProductSopMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/move_up",
		method: "post",
		data
	})
}
// 拖拽排序
export function apiProductSopDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/drag_sort",
		method: "post",
		data
	})
}

// 生产工序--工序下拉
export function apiWorkStationList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/list",
		method: "post",
		data
	})
}

// 生产工序--上一工序下拉
export function apiProductSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/list",
		method: "post",
		data
	})
}

// 生产工序--标签类型下拉
export function apiLabelType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/label_type",
		method: "post",
		data
	})
}

// 生产工序--局胜制下拉
export function apiBestOf(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/best_of",
		method: "post",
		data
	})
}

// QC报表--测试类型
export function apiQCTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/qc_type",
		method: "post",
		data
	})
}

// QC报表--测试对象类别
export function apiQCTargetTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/qc_target_type",
		method: "post",
		data
	})
}

export function apiResetErrorDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/reset_error",
		method: "post",
		data
	})
}

export function apiUnLockDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/un_lock",
		method: "post",
		data
	})
}
export function apiResetUnpacked(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/reset_unpacked",
		method: "post",
		data
	})
}

// 生产日志--表格查询
export function apiFactoryLogSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_log/search",
		method: "post",
		data
	})
}

export function apiUploadLogSearch(data = {}) {
	return instance({
		url: "aim/api/v3/open_api/SmartBusiness/send_report/search",
		method: "post",
		data
	})
}

export function apiProductSopCopy(data={}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/copy_sop",
		method: "post",
		data
	})
}
export function apiRestoreSop(data={}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/restore",
		method: "post",
		data
	})
}

// 组装工单--锁定
export function apiProductionOrderLock(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/production_order/lock",
		method: "post",
		data
	})
}

// 修改工单数量
export function apiProductionOrderUpdateQuantity(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_quantity",
		method: "post",
		data
	})
}

// 交接工单
export function apiHandoverOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/handover",
		method: "post",
		data
	})
}

export function apiExportWarrantyExtension(data={}) {
	return instance({
		url: "/aim/api/v3/production_order/export_warranty_extension",
		method: "post",
		data
	})
}

// 组装工单--重新打开工单
export function apiProductionOrderReopen(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/reopen",
		method: "post",
		data
	})
}

// 组装工单--解锁
export function apiProductionOrderUnlock(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/production_order/unlock",
		method: "post",
		data
	})
}

// 组装工单--解锁
export function apiProductionOrderPause(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/production_order/pause",
		method: "post",
		data
	})
}

// 组装工单--锁定
export function apiProductionOrderLockDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/lock_device",
		method: "post",
		data
	})
}
// 组装工单--借出
export function apiProductionOrderLendOutDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/lend_out_device",
		method: "post",
		data
	})
}
export function apiProductionOrderLockDevice2(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/lock_device2",
		method: "post",
		data
	})
}

export function apiProductionOrderOtaDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/ota_device",
		method: "post",
		data
	})
}
// 组装工单--批量锁定
export function apiProductionOrderBatchLockDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/batch_lock_device",
		method: "post",
		data
	})
}

// 组装工单--解锁
export function apiProductionOrderUnlockDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unlock_device",
		method: "post",
		data
	})
}
// 组装工单--批量解锁
export function apiProductionOrderBatchUnlockDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/batch_unlock_device",
		method: "post",
		data
	})
}
// 组装工单--查询组装工单扩展字段信息
export function apiSearchProductionOrderExtend(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/search_order_extend",
		method: "post",
		data
	})
}
// 修改裸机称重
export function apiProductionOrderUpdateWeight(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_weight",
		method: "post",
		data
	})
}
// 组装工单--新增组装工单扩展字段信息
export function apiAddProductionOrderExtend(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/add_order_extend",
		method: "post",
		data
	})
}
// 组装工单--修改组装工单扩展字段信息
export function apiUpdateProductionOrderExtend(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/update_order_extend",
		method: "post",
		data
	})
}
// 组装工单--删除组装工单扩展字段信息
export function apiDeleteProductionOrderExtend(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/delete_order_extend",
		method: "post",
		data
	})
}
